import { useQuery } from '@tanstack/react-query';

import { ValidationType } from 'src/features/validationTypes/utils/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { CURRENCY } from 'src/types';

const RESOURCE = `sp-core/:parkingId/validations/validation-type/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    validator_account?: string;
    currency?: CURRENCY;
    parkingId: string;
    cloud_user?: string;
}

const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<ValidationType>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_VALIDATION_TYPES_RESOURCE, useQueryHook as useListValidationTypes };
